import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TableHeaderColumn = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          d="M9.5 3H6v2.5h3.5V3ZM6 6.5h3.5v3H6v-3Zm0 4h3.5V13H6v-2.5ZM9.5 2H14c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H2a1 1 0 0 1-1-1V3c0-.6.4-1 1-1h7.5ZM14 6.5v3h-3.5v-3H14Zm0 4h-3.5V13H14v-2.5Zm-3.5-5H14V3h-3.5v2.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default TableHeaderColumn
